export default "__VITE_ASSET__AC8dHXe8__"